<template>
  <div class="news_recommend_content">
    <div class="news_recommend_head">
      <h3>{{ newsRecommendObj.title }}</h3>
      <span @click="sendData()">{{ newsRecommendObj.text }}</span>
    </div>

    <ul>
      <div v-for="(item,index) in newsRecommendObj.newData" :key="index">
        <!-- <img v-if="index == 0" :src="item.cover" @click="goToDetail(item)"> -->
        <li @click="goToDetail(item)">{{item.title}}</li>
      </div>
    </ul>
  </div>
</template>

<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  props: ["newsRecommendObj", "urlType"],
  methods: {
    sendData() {
      this.$emit("dataRefresh");
    },
    sendImgUrl(item) {
      this.$emit("sendImgUrl", item);
    },
    goToDetail(item) {
      // this.$router.push({
      //   path: `/${this.urlType}`,
      //   query: {
      //     id: item.id,
      //   },
      // });
      routerGoNewpage(`/${this.urlType}`,{id:item.id})
    },
  },
};
</script>

<style scoped lang="less">
.news_recommend_content {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  padding: 16px 16px 0;
  .news_recommend_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed #e1e1e1;
    padding-bottom: 15px;
    span {
      cursor: pointer;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      &::before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        background: url("../assets/images/break.png") no-repeat center/100%;
        vertical-align: top;
        margin-right: 10px;
      }
    }
  }
  img {
    width: 100%;
    height: 168px;
    margin: 15px 0 0;
    &:hover{
      cursor: pointer;
    }
  }
  ul {
    div{
      border-bottom: 1px dashed #e1e1e1;
      &:last-child{
        border: none;
      }
    li {
      cursor: pointer;
      font-size: 14px;
      height: 54px;
      line-height: 54px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      // padding: 10px 0;
      // border-bottom: 1px dashed #e1e1e1;
      // 单行溢出省略
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:last-of-type {
        padding-bottom: 0;
        border-bottom: 0;
      }
      &:hover {
        color: #ff8a02;
      }
      &:first-child div{
        height: 300px;
      }
    }
   }
  }
}
.bord_er{
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/common/newsRecom.vue